import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en, es, id, ja, ko, pt, zh } from '@/language';

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  lng: 'ko',
  fallbackLng: 'en',
  debug: false,
  resources: {
    ...ko,
    ...en,
    ...es,
    ...id,
    ...pt,
    ...ja,
    ...zh,
  },
});

export { i18n };
